import { FaSnowflake, FaHeart, FaGift } from "react-icons/fa";
import { useState, useEffect } from "react";

function Footer() {
  const [isDesktop, setDesktop] = useState(window.innerWidth > 1050);

  const updateMedia = () => {
    setDesktop(window.innerWidth > 1050);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  return (
    <footer
      className="relative text-white pb-8 pt-12 mt-24"
      style={{
        background: "linear-gradient(135deg, #1B5E20, #2E7D32)",
        borderTop: "8px solid #FFD700",
        boxShadow: "0 -10px 40px rgba(0, 0, 0, 0.2)",
      }}
    >
      {/* Decorative snowflakes */}
      <div className="absolute top-0 left-0 w-full overflow-hidden pointer-events-none">
        <FaSnowflake
          className="absolute text-white opacity-20"
          style={{ top: "10px", left: "5%", fontSize: "24px" }}
        />
        <FaSnowflake
          className="absolute text-white opacity-20"
          style={{ top: "20px", left: "15%", fontSize: "18px" }}
        />
        <FaSnowflake
          className="absolute text-white opacity-20"
          style={{ top: "15px", right: "10%", fontSize: "20px" }}
        />
        <FaSnowflake
          className="absolute text-white opacity-20"
          style={{ top: "25px", right: "20%", fontSize: "16px" }}
        />
      </div>

      {!isDesktop ? (
        <div className="flex flex-col items-center justify-center space-y-6 w-full px-4">
          {/* Logo/Title */}
          <div
            className="flex items-center space-x-3"
            style={{
              fontFamily: "'Cabin Sketch', cursive",
              fontSize: "1.8rem",
              textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
            }}
          >
            <span className="text-[#FFF8F0]">Advent of Apex</span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-4 text-[#FFF8F0]">
            <a
              href="https://minniesfoodpantry.org"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#FFD700] transition-all duration-300 font-bold px-3 py-2 rounded-lg hover:bg-white hover:bg-opacity-10 flex items-center gap-2"
              style={{ fontSize: "1rem" }}
            >
              <FaGift /> Minnie&apos;s Food Pantry
            </a>
            <a
              href="https://tally.so/r/mDzZVj"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#FFD700] transition-all duration-300 font-bold px-3 py-2 rounded-lg hover:bg-white hover:bg-opacity-10"
              style={{ fontSize: "1rem" }}
            >
              Feedback
            </a>
            <a
              href="https://join.slack.com/t/campapexorg/shared_invite/zt-2x349b383-zEistSk09EI79TBm8TIkjw"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#FFD700] transition-all duration-300 font-bold px-3 py-2 rounded-lg hover:bg-white hover:bg-opacity-10"
              style={{ fontSize: "1rem" }}
            >
              Slack
            </a>
          </div>

          {/* Made with love */}
          <div
            className="text-center text-[#FFF8F0] opacity-90"
            style={{ fontSize: "1rem", fontWeight: "600" }}
          >
         
            <p className="mt-2 text-sm">© 2025 Advent of Apex</p>
          </div>
        </div>
      ) : (
        <div className="max-w-7xl mx-auto px-8">
          <div className="grid grid-cols-3 gap-16">
            {/* Logo Section */}
            <div className="col-span-1">
              <div
                className="flex items-center space-x-3 mb-4"
                style={{
                  fontFamily: "'Cabin Sketch', cursive",
                  fontSize: "2rem",
                  textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
                }}
              >
                <div className="flex flex-col">
                  <span className="text-[#FFF8F0] leading-tight">
                    Advent of Apex
                  </span>
                </div>
              </div>
              <p className="text-[#FFF8F0] opacity-90 text-sm font-semibold">
                25 days of Salesforce challenges
              </p>
            </div>

            {/* Good Cause */}
            <div>
             
             
            </div>

            {/* Connect */}
            <div>
              <h3
                className="text-[#FFD700] text-xl font-bold mb-4"
                style={{ fontFamily: "'Cabin Sketch', cursive" }}
              >
                Connect
              </h3>
              <div className="space-y-3">
                <a
                  href="https://join.slack.com/t/campapexorg/shared_invite/zt-2x349b383-zEistSk09EI79TBm8TIkjw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-[#FFF8F0] hover:text-[#FFD700] transition-all duration-300 font-bold text-lg hover:translate-x-2"
                >
                  Join Slack
                </a>
                <a
                  href="https://tally.so/r/mDzZVj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-[#FFF8F0] hover:text-[#FFD700] transition-all duration-300 font-bold text-lg hover:translate-x-2"
                >
                  Give Feedback
                </a>
              </div>
            </div>
          </div>

        </div>
      )}
    </footer>
  );
}

export default Footer;
